import { novelThumbnailBackgroundColorArray } from "../../../../constants";
import {capitalizeString} from "../../../../lib/utils/index"
const getLines = (ctx,text,maxWidth) => {
  var words = text.split(" ");
    var lines = [];
    var currentLine = words[0];

    for (let i = 1; i < words.length; i++) {
        var word = words[i];
        var width = ctx.measureText(currentLine + " " + word).width;
        if (width < maxWidth) {
            currentLine += " " + word;
        } else {
            lines.push(currentLine);
            currentLine = word;
        }
    }
    lines.push(currentLine);
    return lines;
}

 function wrapText(ctx, text, canvas,x, y, maxWidth, lineHeight) {
    const lines = getLines(ctx,text,maxWidth)
    for(let i=0;i<lines.length;i++){
      const testWidth = ctx.measureText(lines[i]).width;
      ctx.fillText(lines[i],(canvas.width/2 - testWidth/2),y);
      y+=lineHeight
    }
}

const getFontSizeAndLineHeight = (text) => {
  const numWords = text.split(' ').length;
  let size = 50;
  let lineHeight = 56;
  if(numWords >= 1 && numWords <=3){
    size = 64;
    lineHeight = 64;
  }else if(numWords >= 4 && numWords <=6){
    size = 50;
    lineHeight = 50;
  }else if(numWords >= 7 && numWords <=9){
    size = 40;
    lineHeight = 48;
  }else{
    size = 30;
    lineHeight = 40;
  }
  return [`${size}px`,lineHeight]
}

const getYCord = (lines) => {
  let yCord = 180;
  if(lines >= 2 && lines < 5){
    yCord = 130;
  }else if(lines >= 5){
    yCord = 80;
  }
  return yCord;
}

const getContrastYIQ = (hexcolor) => {
  const colorCode = hexcolor.slice(0);
  const r = parseInt(colorCode.substr(0,2),16);
  const g = parseInt(colorCode.substr(2,2),16);
  const b = parseInt(colorCode.substr(4,2),16);
  const yiq = ((r*299)+(g*587)+(b*114))/1000;
  return (yiq >= 128) ? 'black' : 'white';
}

  function generateImage(novelName,authorName){
    const capitalizeNovelName = capitalizeString(novelName)
    const [firstName, lastName] = authorName.split(" ")
    const capitalizeAuthorName = capitalizeString(firstName) + " " + capitalizeString(lastName)
    const canvas = document.createElement("canvas");
    canvas.width  = 300;
    canvas.height = 450;
    var ctx = canvas.getContext("2d");
    const randomColorIndex = Math.floor(Math.random() * novelThumbnailBackgroundColorArray.length);
    const randomColor =  novelThumbnailBackgroundColorArray[randomColorIndex]
    ctx.fillStyle = randomColor;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = getContrastYIQ(randomColor);
    const fontAndLine = getFontSizeAndLineHeight(capitalizeNovelName)
    ctx.font = `${fontAndLine[0]} sans-serif`;
    const lines = getLines(ctx,capitalizeNovelName,200)
    for(let i=0;i<lines.length;i++){
      const testWidth = ctx.measureText(lines[i]).width;
      if(testWidth > canvas.width){
        ctx.font = `32px sans-serif`;
        fontAndLine[1] = 40;
      }
    }
    const yCord = getYCord(lines.length);
    wrapText(ctx,capitalizeNovelName , canvas, 32, yCord, 200,fontAndLine[1]);
    ctx.font = `36px sans-serif`;
    wrapText(ctx,capitalizeAuthorName, canvas,32, 400, 250, 34);
    return canvas;
 }


  export function convertCanvasToImage(novelName,authorName) {
    const canvas = generateImage(novelName,authorName)
    return new Promise(resolve => {
      canvas.toBlob(file => {
        resolve(URL.createObjectURL(file))
      }, 'image/jpeg')
    })
  }

  
  
  